import Blockly from 'blockly/browser'
import { defineBlock, defineStmtBlock } from '../Util'

defineBlock(
  'sirenia_api_fs_tmpfolder',
  {
    message0: 'temporary folder',
    args0: [],
    tooltip: 'Provides the system temp folder path',
    output: null,
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#temp-folder'
  },
  function(block) {
    return [`Fs.tmpFolder`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'sirenia_api_fs_ls',
  {
    message0: '%1 file matching against %2',
    args0: [
      {
        type: 'field_dropdown',
        name: 'SHALLOW',
        options: [['shallow', 'SHALLOW'], ['deep', 'DEEP']]
      },
      {
        type: 'input_value',
        name: 'PATH',
        check: 'String'
      }
    ],
    tooltip: 'Lists files matching the given pattern with shallow or deep listing',
    output: null,
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#list-ls'
  },
  function(block) {
    const deep = block.getFieldValue('SHALLOW') === 'DEEP'
    const path =
      Blockly.JavaScript.valueToCode(block, 'PATH', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    return [`Fs.ls(${path}${deep ? `, { deepMatch: true }` : ''})`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineStmtBlock(
  'sirenia_api_fs_write',
  {
    message0: 'write text %2 to file %1',
    args0: [
      {
        type: 'input_value',
        name: 'PATH',
        check: 'String'
      },
      {
        type: 'input_value',
        name: 'TEXT',
        check: 'String',
        align: 'RIGHT'
      }
    ],
    tooltip: "Writes text to a file. Creates the file if it doesn't exist",
    helpUrl:
      'http://sirenia.eu/product/configuration-interface/documentation/flows/#update-multiple-cells'
  },
  function(block) {
    var path =
      Blockly.JavaScript.valueToCode(block, 'PATH', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    var text =
      Blockly.JavaScript.valueToCode(block, 'TEXT', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    return `Fs.write(${path}, ${text});\n`
  }
)

defineBlock(
  'sirenia_api_fs_tmpfile',
  {
    message0: 'path of new temporary file',
    args0: [],
    tooltip: 'Provides path to new temporary file',
    output: null,
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#temp-file'
  },
  function(block) {
    return [`Fs.tmpFile()`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)
